export const ptBR = {
  commons: {
    search: {
      empty: 'Não há registros de {name} a serem exibidos.',
      filter: {
        empty: 'Nenhum registro foi encontrado com os critérios de busca.',
      },
    },
    contactUs: 'Por favor, entre em contato através do chat para falar com nossa equipe.',
  },

  toast: {
    downloadSuccess: 'Download iniciado. Verifique o arquivo em seu computador.',
    getTableDataError:
      'Não foi possível carregar os dados. Por favor, tente novamente mais tarde. Se o problema persistir, entre em contato com o suporte@agnes.com.br',
    downloadError:
      "{'Não foi possível iniciar o download. Por favor, tente novamente mais tarde. Se o problema persistir, entre em contato com o suporte@agnes.com.br.'}",
    exportSuccess:
      'Sua solicitação de exportação foi recebida com sucesso! Faça o download assim que o arquivo estiver disponível no menu "Exportações" (<span class="material-symbols-outlined" style="font-size:16px">download_2</span>).',
    exportError:
      '<strong>Não foi possível processar sua solicitação de exportação.</strong> Por favor, tente novamente mais tarde. Se o problema persistir, entre em contato com o suporte@agnes.com.br.',
  },

  company: {
    hintBotDays:
      'A configuração padrão para este campo é de 5 dias antes da data de vencimento da certidão vigente. Se precisar personalizar, especifique o número de dias para a coleta.',
    hintBotRetroactiveMonth:
      'A configuração padrão para este campo é de 60 meses. Se precisar personalizar, especifique o número de meses para a coleta retroativa.',
    hintBotRetroactiveDay:
      'A configuração padrão para este campo é de 18 dias. Se precisar personalizar, especifique o número de dias para a coleta retroativa.',
  },

  config: {
    noEmployerRegistered: 'Sua conta ainda não possui empregador(es) atribuído(s).',
  },

  eSocial: {
    employers: {
      title: 'Empregadores',
      subtitle: 'Visualize dados dos empregadores registrados no eSocial',
      fieldNotFilled: 'Campo sem preenchimento no xml',
      missingUnknowEvent: 'Ausência de evento de admissão, desligamento ou afastamento.',
    },
  },
  trabalhador: {
    cbo: {
      tabRisco: {
        graficoExposicaoHelper:
          'O gráfico de riscos considera apenas os itens analisados e que possuem algum risco relacionado. Os itens com risco são distribuídos de acordo com o grau de risco, para mais detalhes quanto os critérios de classificação de risco acesse a matriz de exposição.',
      },
    },
    horariosJornada: {
      detalhes: {
        abaHorarioJornada: {
          alerta:
            '<strong>Versões anteriores do eSocial!</strong> O evento S-1050, que era usado para cadastrar tabelas de horários/turnos de trabalho, não faz mais parte do leitaute do eSocial simplificado (versão S-1.0), que entrou em vigor em 2021.',
        },
      },
    },
  },

  folhaDePagamento: {
    pisPasepHelper:
      'Código de incidência relacionado ao recolhimento de encargos destinados ao Programa de Integração Social (PIS) ou ao Programa de Formação do Patrimônio do Servidor Público (PASEP)',
    rubrica: {
      alerta: {
        excecao:
          'Caso possua processo administrativo ou judicial com decisão/sentença favorável, determinando a não incidência de encargos relativos à rubrica, as informações serão exibidas aqui com o detalhamento do processo registrado através de evento específico (S-1070).',
      },
      dialog: {
        excecao:
          'Após esclarecer as informações com o cliente sobre a rubrica em questão, preencha os campos abaixo para efetuar o registro sobre casos de exceção não registrados no S-1070',
      },
      tabItem: {
        informacoes: {
          notificacaoAnaliseInvalida:
            'Você sinalizou o item como analisado, no entanto, há campos de análise obrigatórios sem preenchimento. <br> Proceda com o preenchimento dos campos faltantes ou altere a etapa de análise se deseja salvar.',
          notificacaoAnaliseIncompleta:
            'Identificamos campos sem preenchimento <strong>({campos})</strong>, gostaria de continuar as análises e preencher os itens faltantes ou deseja salvar apenas os itens já preenchidos mantendo os demais campos sem preenchimento?',
          notificacaoAlteracoesNaoSalvas: 'Há alterações que não foram salvas, gostaria de salvar?',
        },
      },
    },
    tabitem: {
      risco: {
        graficoHelper:
          'O gráfico de riscos considera apenas os itens analisados e que possuem algum risco relacionado. Os itens com risco são distribuídos de acordo com o grau de risco, para mais detalhes quanto os critérios de classificação de risco acesse a matriz de exposição.',
      },
    },
  },

  importarTrabalhadores: {
    mensagem:
      'Prezado fornecedor,Esta etapa deve ser realizada somente nos casos em que não houver outorga do eSocial para acesso às informações.Solicitamos que informe a relação nominal dos colaboradores alocados na prestação de serviços à contratante durante o mês contábil.O envio das informações deve ser realizado utilizando o modelo de planilha padrão disponibilizado, garantindo o correto carregamento dos dados.',
  },

  certificate: {
    status: {
      '-1': {
        name: 'N/A',
        orientation:
          "{'A coleta de certidões para este CNPJ esta desabilitada. Caso tenha dúvidas ou deseje habilitar contate nosso time em suporte@agnes.com.br.'}",
      },

      0: {
        name: 'N/A',
        orientation:
          "{'Não foi possível emitir a certidão. Realizaremos novas tentativas de coleta. Em caso de dúvidas ou se desejar orientações adicionais contate suporte@agnes.com.br.'}",
      },

      1: {
        name: 'N/A',
        orientation: 'Certidão emitida com sucesso, você pode baixá-la no ícone de download no menu de ações.',
      },

      2: {
        name: 'N/A',
        orientation: 'Certidão emitida com sucesso, você pode baixá-la no ícone de download no menu de ações.',
      },

      3: {
        name: 'N/A',
        orientation:
          "{'Não foi possível emitir a certidão, consulte o relatório de situação fiscal para visualizar as pendências sinalizadas pela RFB. Em caso de dúvidas ou se desejar orientações adicionais contate suporte@agnes.com.br.'}",
      },

      4: {
        name: 'N/A',
        orientation:
          'Não foi possível emitir a certidão, foi sinalizado a existência de situação cadastral impeditiva. Entre em contato com nossos especialistas mediante suporte@agnes.com.br.',
      },

      5: {
        name: 'Análise inconsistente',
        orientation:
          "{'Não foi possível emitir a certidão, foi sinalizado que durante a tentativa de emissão estava ocorrendo alguma atualização de base de dados da RFB. Realizaremos novas tentativas de coleta assim que o ambiente estiver normalizado. Em caso de dúvidas ou se desejar orientações adicionais contate suporte@agnes.com.br.'}",
      },

      6: {
        name: 'Alguma base de apoio à verificação do contribuinte está indisponível',
        orientation:
          "{'Não foi possível emitir a certidão, foi sinalizado a indisponibilidade de um dos sistemas necessários para a emissão de certidão durante o processamento da requisição. Realizaremos novas tentativas de coleta assim que o ambiente estiver normalizado. Em caso de dúvidas ou se desejar orientações adicionais contate suporte@agnes.com.br.'}",
      },

      7: {
        name: 'Chave de consulta em processamento',
        orientation:
          "{'Não foi possível emitir a certidão, foi sinalizado instabilidade sistêmica durante o processamento do pedido de emissão da certidão. Realizaremos novas tentativas de coleta assim que o ambiente estiver normalizado. Em caso de dúvidas ou se desejar orientações adicionais contate suporte@agnes.com.br.'}",
      },
    },
  },

  terceiros: {
    commons: {
      history: {
        title: 'Histórico de atualização',
        updatedBy: 'Atualizada realizada por:',
        createdBy: 'Criada por:',
        dateTime: 'Data/hora',
        oldValues: 'Informação antes da alteração',
        newValues: 'Informação alterada',
        createdValues: 'Informação adicionada',
        endOfHistory: 'Você visualizou todo histórico de alteração desta exceção',
        close: 'Fechar',
      },
      filter: {
        search: 'Buscar',
        clean: 'Limpar filtro',
        apply: 'Aplicar Filtro',
      },
      yes: 'Sim',
      no: 'Não',
      home: 'Home',
      exclude: 'Sim, desejo excluir',
      uncheck: 'Desmarcar contratantes relacionados ',
      warning: 'Atenção! Item já cadastrado.',
      warningPlural: 'Atenção! Itens já cadastrados.',
      warningDetails: 'Detalhes',
      warningExistingPhrase: 'Identificamos que consta um registro cadastrado para os seguintes dados:',
    },
    outsources: {
      register: {
        create: {
          title: 'Adicionar Terceiro',
          subtitle: 'Preencha as informações abaixo',
        },
        edit: {
          title: 'Editar Terceiro',
          subtitle: 'Preencha as informações abaixo',
        },
        list: {
          title: 'Listagem de Terceiros',
          subtitle: 'Monitore os terceiros cadastrados',
          seeThird: 'Ver terceiros com monitoramento inativo',
          table: {
            notInformed: 'Não informado',
            contractor: 'Contratante',
            outsource: 'Terceiro',
            cnpj: 'Terceiro CNPJ Matriz',
            establishments: 'Estabelecimentos',
            city: 'Cidade - UF',
            stateLabel: 'UF do Terceiro',
            cityLabel: 'Cidade do Terceiro',
            contractStartDate: 'Início da prestação de serviço',
            contractEndDate: 'Fim da prestação de serviço',
            contractStatus: 'Situação contratual',
            monitoring: 'Monitoramento',
            eSocial: 'Outorga eSocial',
            dctf: 'Outorga DCTF',
            digitalFgts: 'Outorga FGTS Digital',
            taxSituation: 'Outorga Situação Fiscal',
            action: 'Ações',
            search: 'Pesquisar por CNPJ ou nome do terceiro',
            digitalCertificateEnabled: 'ID do Certificado Habilitado',
            digitalCertificateDisabled: 'Não',
            seeHistory: 'Histórico',
            edit: 'Editar',
            view: 'Visualizar',
            delete: 'Excluir',
            deleteDisabled: 'Exclusão Desabilitada',
          },
          tooltip: {
            eSocial: {
              title: 'Informação',
              content: 'A <b>outorga do eSocial</b> concede acesso necessário para a coleta dos XMLs do eSocial.',
            },
            dctf: {
              title: 'Informação',
              content:
                'A <b>outorga do DCTF</b> concede acesso necessário para a coleta de dados relacionados ao recolhimento de encargos.',
            },
            digitalFgts: {
              title: 'Informação',
              content:
                'A <b>outorga do FGTS digital</b> permite consultar os dados de FGTS que são utilizados para a checagem de encargos.',
            },
            taxSituation: {
              title: 'Informação',
              content:
                'A <b>outorga de situação fiscal</b> permite emitir o relatório de situação fiscal da PGFN para a checagem de pendências relacionadas a encargos federais.',
            },
          },
          filter: {
            contractor: 'Contratante',
            outsources: 'Terceiro',
            state: 'UF',
            city: 'Cidade',
            contractStartDate: 'Início da prestação de serviço',
            contractEndDate: 'Fim da prestação de serviço',
            contractStatus: 'Situação Contratual',
            eSocial: 'Outorga eSocial',
            fgts: 'Outorga FGTS Digital',
            dctf: 'Outorga DCTF Web',
            taxSituation: 'Outorga Situação Fiscal',
            digitalCertificate: 'Certificado Digital',
            watching: 'Monitoramento',
          },
          thirdListing: 'Listagem de terceiros',
        },
        form: {
          contractor: 'Contratante(s)',
          cnpjLabel: 'Selecione um ou mais CNPJs conforme o contrato',
          thirdLabel: 'Terceiro',
          initialWorkLabel: 'Início da prestação de serviço',
          endWorkLabel: 'Fim da prestação de serviço',
          terminationDate: 'Encerramento antecipado *',
          renderFinished: 'Prestação encerrada antecipadamente',
          receiveGrants: 'Outorgas recebidas',
          eSocialLabel: 'eSocial',
          dctfLabel: 'DCTF Web',
          fgtsLabel: 'FGTS Digital',
          fiscalSituation: 'Situação Fiscal',
          workPeriod: 'Período de prestação de serviços',
          cnpj: 'CNPJ *',
          contractStartDate: 'Início de Contrato',
          contractEndDate: 'Fim de Contrato',
          contractEndedEarlyDate: 'Data Encerramento Antecipado',
          contractEndedEarly: 'Contrato Encerrado Antecipadamente',
          socialReason: 'Razão Social do Contratado *',
          establishments: 'Estabelecimentos *',
          establishmentsAmountLabel: 'Quantidade de estabelecimentos do terceiro',
          establishmentsAmoutHeadquarters: 'Número total de estabelecimentos (matriz + filiais)',
          establishmentsHint: 'Preencha apenas números, total de estabelecimentos (matriz + filiais) do contratado',
          state: 'UF do Contratado *',
          city: 'Cidade do Contratado *',
          eSocial: 'Outorga eSocial',
          dctf: 'Outorga DCTF',
          taxSituation: 'Outorga Situação Fiscal',
          digitalCertificate: 'Certificado Digital',
          watching: 'Monitoramento',
          obligatoryFields: '* Campos de preenchimento obrigatório',
          cancelButton: 'Cancelar',
          saveButton: 'Salvar',
          thirdEdit: 'Editar terceiro',
          thirdRegister: 'Adicionar terceiro',
          thirdReadOnly: 'Visualizar terceiro',
          requestThirdEdit: 'Edite as informações do terceiro',
          fillThirdEdit: 'Preencha as informações do terceiro',
          phrase:
            'Para continuar com o cadastro, é preciso desmarcar os seguintes contratantes relacionados ao terceiro:',
        },
        totalizators: {
          watched: {
            title: 'Registros <strong>monitorados</strong>',
            description: '{percentage}% em relação aos registros cadastrados ({total})',
            tooltip: {
              title: 'Informação',
              content:
                '<b>Monitoramento</b>: <br/> É possível habilitar e desabilitar o monitoramento dos seus terceiros. Períodos em que o monitoramento esteve desabilitado são desconsiderados para fins de coleta de dados.',
            },
          },
          active: {
            title: 'Registros com <strong>serviço ativo</strong>',
            description: '{percentage}% em relação aos registros cadastrados',
          },
          finished: {
            title: 'Registros com <strong>serviço encerrado</strong>',
            description: '{percentage}% em relação aos registros cadastrados',
          },
        },
        delete: {
          title: 'Excluir cadastro',
          subtitle: 'Deseja realmente excluir este cadastro? <br /> Esta ação não poderá ser desfeita.',
        },
      },
      paymentRoll: {
        list: {
          title: 'Folha de Pagamento de Terceiros',
          subtitle: 'Monitore os riscos relacionados a terceirização de mão de obra',
        },
      },
    },
    notifications: {
      error: {
        searchContracts:
          'Ocorreu um erro ao buscar os dados. Se o problema persistir, entre em contato com o suporte@agnes.com.br.',
        loadExternalOptions:
          'Ocorreu um erro ao buscar as dados de contratantes ou terceiros, tente novamente mais tarde.',
        getEncargosRecolhimentoInsideTable:
          'Ocorreu um erro ao buscar os dados da tabela interna, tente novamente mais tarde.',
        export:
          '<strong>Não foi possível processar sua solicitação de exportação.</strong> Por favor, tente novamente mais tarde. Se o problema persistir, entre em contato com o suporte@agnes.com.br.',
        errorGetFolhaPagamentoAnaliticaModal:
          'Ocorreu um erro ao buscar os dados da folha de pagamento analítica, tente novamente mais tarde.',
      },
      success: {
        updateContract: 'Cadastro editado com sucesso.',
        export:
          'Sua solicitação de exportação foi recebida com sucesso! Faça o download assim que o arquivo estiver disponível no menu "Exportações" (<span class="material-symbols-outlined" style="font-size:16px">download_2</span>).',
      },
      errorGetFolhaPagamentoAnalitica:
        'Ocorreu um erro ao buscar os dados da folha de pagamento analítica, tente novamente mais tarde.',
    },
    charges: {
      page: {
        title: 'Encargos por código de recolhimento',
        subtitle:
          'Monitore os riscos relacionados a terceirização de mão de obra relacionada ao não recolhimento de encargos.',
        breadcrumb: {
          outsources: 'Terceiros',
          charges: 'Encargos de terceiros',
          chargesByPaymentCode: 'Encargos por código de recolhimento',
        },
        loading: 'Carregando...',
        contractor: 'Contratante',
        outsource: 'Terceiro',
        period: 'Período de apuração',
        total: 'Total de Encargos',
        seeDcomp: 'Visualizar PER/DCOMP',
        noDcomp: 'Nenhuma PER/DCOMP a ser exibida.',
      },
      breadcrumb: {
        charges: 'Encargos de terceiros',
        chargesByPaymentCode: 'Encargos por código de recolhimento',
      },
      mainTable: {
        headers: {
          dataTableExpand: '',
          name: 'Tributo',
          calculatedDebt: 'Débito apurado',
          deductions: 'Deduções',
          otherCredits: 'Outros créditos',
          balanceToRecive: 'Valor a recolher',
          nonCollection: 'Ausência de recolhimento',
          balanceToPay: 'Valor a recolher',
          actions: 'Ações',
        },
      },
      exportOptionsNames: {
        outros: 'Apenas outros encargos',
        fgts: 'Apenas FGTS',
        irrf: 'Apenas IRRF',
        inss: 'Apenas Contribuição Previdenciária',
        all: 'Todos os encargos',
      },
      missingOutorgas: {
        fgts: 'Ausência de outorga para acesso aos dados do FGTS Digital',
        irrf: 'Ausência de outorga para acesso aos dados da DCTF Web',
        inss: 'Ausência de outorga para acesso aos dados da DCTF Web',
        outros: 'Ausência de outorga para acesso aos dados da DCTF Web',
      },
      collectionCode: 'Código de Recolhimento',
      goBack: 'Voltar a página anterior',
      inputs: {
        contractor: 'Contratante',
        outsource: 'Terceiro',
        period: 'Período de apuração',
      },
      dcomp: {
        title: 'Número de PER/DCOMP',
        close: 'Fechar',
        loadedAll: 'Você visualizou todos os PER/DCOMP.',
      },

      details: {
        expandedDetails: 'Exibir Detalhes',
        hideDetails: 'Ocultar Detalhes',
      },

      cases: {
        registered: 'Cadastrado',
        notRegistered: 'Não informado',
        unavailable: 'Indisponível',
        unwatched: 'Desabilitado',
        notAplicable: 'Não aplicável',
      },
    },
    payroll: {
      header: {
        title: 'Folha de Pagamento de Terceiros',
        subtitle: 'Monitore os riscos relacionados a terceirização de mão de obra.',
      },
      breadcrumb: {
        home: 'Home',
        outsources: 'Terceiros',
        payroll: 'Folha de Pagamento',
      },
      tabLabels: {
        summary: 'Resumo',
        synthetic: 'Sintética',
        analytical: 'Analítica',
      },
      filter: {
        contractor: 'Tomador de Serviço',
        contractorPlaceholder: 'Pesquise um tomador',
        outsources: 'Terceirizado',
        outsourcesPlaceholder: 'Selecione um terceirizado',
        period: 'Período de Apuração',
        periodPlaceholder: 'Selecione um período',
        search: 'Buscar por terceiro',
      },

      table: {
        summary: {
          headers: {
            contractorName: 'Tomador de Serviço',
            outsourceName: 'Terceiro',
            calculationPeriod: 'Período de apuração',
            allocatedWorkers: 'Trabalhadores Alocados',
            totalEarnings: 'Total de Proventos',
            totalDiscounts: 'Total de Descontos',
            totalInformativeValues: 'Total de Valores Informativos',
            netPayroll: 'Líquido de Folha',
            cpBase: 'Base CP',
            employerCp: 'CP Patronal',
            employerCpBase: 'Base CP Patronal',
            insuredCp: 'CP Segurado',
            irrfBase: 'Base IRRF',
            irrf: 'IRRF',
            fgts: 'FGTS',
            fgtsBase: 'Base FGTS',
            pisPasepBase: 'Base PIS/PASEP',
            totalCharges: 'Total de Encargos',
            nonCollection: 'Ausência de Recolhimento',
            action: 'Ações',
          },
        },
        synthetic: {
          headers: {
            contractorName: 'Tomador de Serviço',
            outsourceName: 'Terceiro',
            calculationPeriod: 'Período de Apuração',
            rubricCode: 'Código Rubrica',
            rubricDescription: 'Descrição da Rubrica',
            rubricType: 'Tipo de Rubrica',
            rubricValue: 'Valor Rubrica',
            cpBase: 'Base Cálculo CP',
            employerCpBase: 'Base Cálculo CP Patronal',
            insuredCp: 'Base Cálculo CP Segurado',
            irrfBase: 'Base Cálculo IRRF',
            fgtsBase: 'Base Cálculo FGTS',
            pisPasepBase: 'Base Cálculo PIS/PASEP',
            allocatedWorkers: 'Trabalhadores',
            action: 'Ações',
          },
        },
      },

      modal: {
        synthetic: {
          allocatedEmployees: 'Total de trabalhadores alocados: {total}',
          competence: 'Competência: {competence}',
          totalValue: 'Valor total: {total}',
        },
      },

      tabs: {
        summary: {
          export: 'Exportar',
          title: 'Resumo',
          filter: {
            contractor: 'Contratante',
            contractorPlaceholder: 'Selecione um contratante',
            outsources: 'Terceirizado',
            outsourcesPlaceholder: 'Selecione um terceirizado',
            period: 'Período de Apuração',
            periodPlaceholder: 'Selecione um período',
            search: 'Pesquisar por CNPJ ou nome do terceiro',
          },
          table: {
            headers: {
              contractorName: 'Tomador de Serviço',
              outsourceName: 'Terceiro',
              calculationPeriod: 'Período de apuração',
              allocatedWorkers: 'Trabalhadores Alocados',
              totalEarnings: 'Total de Proventos',
              totalDiscounts: 'Total de Descontos',
              totalInformativeValues: 'Total de Valores Informativos',
              netPayroll: 'Líquido de Folha',
              cpBase: 'Base CP',

              employerCp: 'CP Patronal',
              employerCpBase: 'Base CP Patronal',
              insuredCp: 'CP Segurado',
              irrfBase: 'Base IRRF',
              irrf: 'IRRF',
              fgts: 'FGTS',
              fgtsBase: 'Base FGTS',
              pisPasepBase: 'Base PIS/PASEP',
              totalCharges: 'Total de Encargos',
              nonCollection: 'Ausência de Recolhimento',
              action: 'Ações',
            },
          },
          modal: {
            description: 'Alocados em: <strong> {contractorName} - {contractorCnpj}</strong>',
            allocatedEmployees: 'Total de trabalhadores alocados: {total}',
            competence: 'Competência: {competence}',
          },
        },
        analytical: {
          export: 'Exportar',
          filter: {
            contractor: 'Contratante',
            contractorPlaceholder: 'Selecione um contratante',
            outsources: 'Terceirizado',
            outsourcesPlaceholder: 'Selecione um terceirizado',
            period: 'Período de Apuração',
            periodPlaceholder: 'Selecione um período',
            search: 'Pesquisar por CPF ou nome do trabalhador',
          },
          table: {
            headers: {
              contractorName: 'Tomador de Serviço',
              outsourceName: 'Terceiro',
              calculationPeriod: 'Período de Apuração',
              cpf: 'CPF',
              employee: 'Trabalhador',
              totalEarnings: 'Total de Proventos',
              totalDiscounts: 'Total de Descontos',
              baseCp: 'Base CP',
              totalInformativeValues: 'Total de valores informativos',
              netPayroll: 'Líquido de Folha',
              employerCpBase: 'Base CP Patronal',
              insuredCp: 'CP Segurado',
              employerCp: 'CP Patronal',
              irrfBase: 'Base IRRF',
              irrf: 'IRRF',
              fgtsBase: 'Base FGTS',
              fgts: 'FGTS',
              pisPasepBase: 'Base PIS/PASEP',
              totalCharges: 'Total de Encargos',
              nonCollection: 'Ausência de Recolhimento',
              action: 'Ações',
            },
          },
          details: {
            title: 'Detalhes do trabalhador',
            subtitle: 'Visualize os detalhes do arquivo importado',
            back: 'Voltar a página anterior',
            showDetails: 'Exibir detalhes',
            hideDetails: 'Ocultar detalhes',
            search: 'Pesquisar por rubrica',
            breadcrumbs: {
              outsources: 'Terceiros',
              payroll: 'Folha de Pagamento',
              loading: 'Carregando...',
            },
            table: {
              headers: {
                contractorName: 'Tomador de Serviço',
                outsourceName: 'Terceiro',
                period: 'Período de Apuração',
                cpf: 'CPF',
                employee: 'Trabalhador',
              },
            },
            expandableTable: {
              headers: {
                rubricValue: 'Valor Rubrica',
                rubricCode: 'Código Rubrica',
                rubricDescription: 'Descrição da Rubrica',
                rubricType: 'Tipo de Rubrica',
                reference: 'Referência',
                rubricFactor: 'Fator Rubrica',
                employerCpBase: 'Base Cálculo CP Patronal',
                insuredCpBase: 'Base Cálculo CP Segurado',
                irrfBase: 'Base Cálculo IRRF',
                fgtsBase: 'Base Cálculo FGTS',
                pisPasepBase: 'Base Cálculo PIS/PASEP',
              },
            },
            detailsItems: {
              admission: 'Admissão',
              fired: 'Desligamento',
              employeeRegime: 'Tipo de Regime Trabalhista',
              employeeCategory: 'Categoria do trabalhador',
              nociveAgentExposure: 'Grau exposição à agente nocivo',
              cpBase: 'Base CP',
              insuredCpBase: 'Base CP Segurado',
              irrfBase: 'Base IRRF',
              fgtsBase: 'Base FGTS',
              pisPasepBase: 'Base PIS/PASEP',
              employerCp: 'CP Patronal',
              insuredCp: 'CP Segurado',
              irrf: 'IRRF',
              fgts: 'FGTS',
              totalCharges: 'Total de Encargos',
              totalEarnings: 'Total de Proventos',
              totalDiscounts: 'Total de Descontos',
              netPayroll: 'Líquido de Folha',
              totalInformativeValues: 'Total de Valores Informativos',
              nonCollection: 'Ausência de Recolhimento',
            },
          },
        },
        synthetic: {
          export: 'Exportar',
          filter: {
            contractor: 'Contratante',
            contractorPlaceholder: 'Selecione um contratante',
            outsources: 'Terceirizado',
            outsourcesPlaceholder: 'Selecione um terceirizado',
            period: 'Período de Apuração',
            periodPlaceholder: 'Selecione um período',
            rubricPlaceholder: 'Selecione por rubrica',
            rubric: 'Tipo de Rubrica',
            search: 'Pesquisar por CNPJ ou nome do terceiro',
            apply: 'Aplicar filtro',
            clean: 'Limpar filtro',
          },
          modal: {
            allocatedEmployees: 'Total de trabalhadores: {total}',
            competence: 'Competência: {competence}',
            totalValue: 'Valor total: {total}',
          },
          headers: {
            contractorName: 'Tomador de Serviço',
            outsourceName: 'Terceiro',
            calculationPeriod: 'Período de Apuração',
            rubricCode: 'Código Rubrica',
            rubricDescription: 'Descrição da Rubrica',
            rubricType: 'Tipo de Rubrica',
            rubricValue: 'Valor Rubrica',
            cpBase: 'Base Cálculo CP',
            employerCpBase: 'Base Cálculo CP Patronal',
            insuredCp: 'Base Cálculo CP Segurado',
            irrfBase: 'Base Cálculo IRRF',
            fgtsBase: 'Base Cálculo FGTS',
            pisPasepBase: 'Base Cálculo PIS/PASEP',
            allocatedWorkers: 'Trabalhadores',
            action: 'Ações',
          },
        },
      },
    },
  },
};
